<template>
    <div>
        <PageHeader
            :title="'Product Catalogs'"
            :heroImg="'/images/catalog-hero.webp'"
        />
        <section class="py-6 md:py-16 bg-white">
            <div class="max-w-2xl mx-auto px-6">
                <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8">
                    <LiteratureItem
                        v-for="item in literatureItems"
                        :key="item.id"
                        :href="item.path"
                        :img="item.image_path"
                        :name="item.name"
                    />
                </div>
                <ShowMore
                    class="mt-8"
                    :loaded="literatureItems.length"
                    :total="total"
                    :has-more="hasMore"
                    :loading="loading"
                    @load-more="loadMore"
                />
            </div>
        </section>
    </div>
</template>
<script>
import PageHeader from "@c/PageHeader.vue";
import LiteratureItem from "@c/pages/sales-tools/LiteratureItem.vue";
import ShowMore from "@c/shared/ShowMore.vue";

export default {
    name: "LiteratureNew",
    components: {
        PageHeader,
        LiteratureItem,
        ShowMore,
    },
    data() {
        return {
            literatureItems: [],
            page: 0,
            total: 0,
            hasMore: false,
            loading: false,
        };
    },
    methods: {
        async loadMore() {
            if (this.loading) return;
            this.loading = true;
            try {
                const nextPage = this.page + 1;
                const { data } = await axios.get("/api/literatures", {
                    params: { page: nextPage },
                });
                this.literatureItems = this.literatureItems.concat(data.data || []);
                this.page = data.page || nextPage;
                this.total = data.total || 0;
                this.hasMore = !!data.has_more;
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.loadMore();
    },
};
</script>

<style scoped lang="scss">
</style>
